// src/utils/decrypt.js
import CryptoJS from 'crypto-js';

export function decryptFunction(encryptedData) {
    if (!encryptedData) return '';

    const keyHex = '675228de68b1903428c6288e5b4e16b5bc054dbe4f459a0f2bc4e813c0f14912';
    const key = CryptoJS.enc.Hex.parse(keyHex);

    const ciphertext = encryptedData.split('_').pop();
    const first32Characters = encryptedData.substring(0, 32);
    const iv = CryptoJS.enc.Hex.parse(first32Characters);

    const decrypted = CryptoJS.AES.decrypt({ ciphertext: CryptoJS.enc.Base64.parse(ciphertext) }, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
}
